import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './Message.module.scss';
import PlotInput from './PlotInput';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from './Navbar';

const Message = () => {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]); // State for group members
  const [plots, setPlots] = useState([]);
  const [selectedReceiver, setSelectedReceiver] = useState(null);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [messages, setMessages] = useState([]);
  const [image, setImage] = useState(null);
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [isGroup, setIsGroup] = useState(false);
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');
  const [selectedGroupUsers, setSelectedGroupUsers] = useState([]);
  const [error, setError] = useState('');
  const [currentUser, setCurrentUser] = useState(null); 
  const token = localStorage.getItem('token');

 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, groupsRes, plotsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_URL}/users`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_URL}/groups`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_URL}/plots`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        setUsers(usersRes.data);
        setGroups(groupsRes.data);
        setPlots(plotsRes.data);
      } catch (err) {
        console.error('Failed to fetch users, groups, or plots', err);
      }
    };
    

    const fetchCurrentUser = async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.get(`${process.env.REACT_APP_URL}/auth/me`, { 
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setCurrentUser(res.data);
        } catch (err) {
          setError('Failed to fetch current user');
          console.error(err);
        }
      };

    fetchCurrentUser();
    fetchData();
  }, [token]);

  useEffect(() => {
    const fetchMessagesAndMembers = async () => {
      if (selectedReceiver) {
        try {
          // Fetch messages
          const messagesRes = await axios.get(
            `${process.env.REACT_APP_URL}/${isGroup ? 'groups' : 'messages'}/${selectedReceiver.id}${isGroup ? '/messages' : ""}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setMessages(messagesRes.data);
          setFilteredMessages(messagesRes.data);

          // Fetch group members if it's a group chat
          if (isGroup) {
            const groupMembersRes = await axios.get(
              `${process.env.REACT_APP_URL}/groups/${selectedReceiver.id}/members`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            setGroupMembers(groupMembersRes.data);
          } else {
            setGroupMembers([]); // Clear group members for individual chat
          }
          setError('');
        } catch (err) {
          console.error('Failed to fetch messages or group members', err);
          setError(err.response?.data?.message || 'Failed to fetch messages');
        }
      }
    };

    fetchMessagesAndMembers();
  }, [selectedReceiver, isGroup, token]);

  useEffect(() => {
    const result = messages.filter(message =>
      message.content.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredMessages(result);
  }, [searchQuery, messages]);

  
  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };
  
  const handleSendMessage = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('content', newMessage);
    formData.append('image', image);
    formData.append('plotId', selectedPlot ? selectedPlot.plotId : '');
    formData.append('receiverId', selectedReceiver.id); // Ensure receiverId is appended
  
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/${isGroup ? `groups/${selectedReceiver.id}` : 'messages'}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      setMessages([...messages, res.data]);
      setFilteredMessages([...messages, res.data]);
      setNewMessage('');
      setSelectedPlot(null);
      setImage(null);
    } catch (err) {
      console.error('Failed to send message', err);
    }
  };
  

  

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/groups`, {
        name: newGroupName,
        userIds: selectedGroupUsers,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGroups([...groups, res.data]);
      setShowCreateGroup(false);
      setNewGroupName('');
      setSelectedGroupUsers([]);
    } catch (err) {
      console.error('Failed to create group', err);
    }
  };

  const getUserById = (userId) => {
    const user = isGroup ? groupMembers.find(member => member.id === userId) : users.find(user => user.id === userId);
    return user?.username || 'Unknown';
  };

  const getUserColorById = (userId) => {
    const user = isGroup ? groupMembers.find(member => member.id === userId) : users.find(user => user.id === userId);
    return user?.color || '#ccc'; // Default color if not found
  };

  const findUserInGroup = (userId) => {
   console.log(currentUser.id)
  };
 

  return (
    <>
    <div className="App">
      <Navbar />
      <div className="allContent">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xs="12" lg="12" className='mt-1'>
              <div className='messageContainer'>
                <div className={styles.receiverList}>
                  <h3>Users</h3>
                  <ul>
                    {users.map((user) => (
                      <li
                        key={user.id}
                        className={selectedReceiver && user.id === selectedReceiver.id && !isGroup ? styles.selectedReceiver : ''}
                        onClick={() => { setSelectedReceiver(user); setIsGroup(false); }}
                      >
                        {user.username}
                      </li>
                    ))}
                  </ul>
                  <h3>Groups</h3>
                  <ul>
                    {groups.map((group) => (
                      <li
                        key={group.id}
                        className={selectedReceiver && group.id === selectedReceiver.id && isGroup ? styles.selectedReceiver : ''}
                        onClick={() => { setSelectedReceiver(group); setIsGroup(true); }}
                      >
                        {group.name}
                      </li>
                    ))}
                  </ul>
                  <button onClick={() => setShowCreateGroup(true)}>Create Group</button>
                  {showCreateGroup && (
                    <form onSubmit={handleCreateGroup} className={styles.createGroupForm}>
                      <input
                        type="text"
                        value={newGroupName}
                        onChange={(e) => setNewGroupName(e.target.value)}
                        placeholder="Group Name"
                        required
                      />
                      <div className={styles.userSelect}>
                        {users.map((user) => (
                          <label key={user.id}>
                            <input
                              type="checkbox"
                              value={user.id}
                              onChange={(e) => {
                                const userId = parseInt(e.target.value);
                                setSelectedGroupUsers((prev) =>
                                  e.target.checked ? [...prev, userId] : prev.filter((id) => id !== userId)
                                );
                              }}
                            />
                            {user.username}
                          </label>
                        ))}
                      </div>
                      <button type="submit">Create</button>
                      <button type="button" onClick={() => setShowCreateGroup(false)}>Cancel</button>
                    </form>
                  )}
                </div>
                <div className={styles.messageBox}>
                  <div className={styles.chatHeaderContainer}>
                  {selectedReceiver && (
                  <>
                    <div className={styles.chatHeader}>
                      {isGroup ? selectedReceiver.name : selectedReceiver.username}
                    </div>
                      <div className={styles.searchBar}>
                        <input
                          type="text"
                          placeholder="Search messages..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className={styles.searchInput}
                        />  
                      </div>
                  </>
                  )}
                  </div>
                  {error && <p className={styles.error}>{error}</p>}
                  <div className={styles.messages}>
                    {filteredMessages.map((message) => {
                    const isCurrentUser = isGroup 
                    ? groupMembers.some(() => currentUser.id !== message.senderId)    
                    : message.senderId === selectedReceiver?.id;        
                    
                      const messageClass = isCurrentUser ? styles.sender : styles.user;
                      const backgroundColor = isGroup ? getUserColorById(message.senderId) : (isCurrentUser ? '' : getUserColorById(message.senderId));
                    
                      return (
                          <div
                            key={message.id}
                            className={`${styles.chatMessage} ${messageClass}`}
                            style={{ backgroundColor }}
                          >
                            <p>{message.content}</p>
                            {message.image && (
                              <img
                                src={`${process.env.REACT_APP_URL}uploads/${message.image}`}
                                alt="Attached"
                                className={styles.messageImage}
                              />
                            )}
                            {message.plotId && (
                              <p>
                                Tagged Plot: {plots.find((p) => p.plotId === message.plotId)?.plotId}
                              </p>
                            )}
                            <span className={styles.messageSender}>
                              {getUserById(message.senderId)}
                            </span>
                          </div>
                        );
                    })}
                  </div>
                  <form onSubmit={handleSendMessage} className='Message_sendForm'>
                    <input
                      type="text"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      placeholder="Type your message..."
                      required
                    />
                    <div className={styles.fileInputContainer}>
                      <input type="file" id="imageUpload" className={styles.fileInput} accept="image/*" onChange={handleImageChange} />
                      <label htmlFor="imageUpload" className={styles.cameraIcon}></label>
                    </div>
                      <PlotInput selectedPlot={selectedPlot} plots={plots} setSelectedPlot={setSelectedPlot}/>
                    <button type="submit">Send</button>
                  </form>
                  {/* <form onSubmit={handleSendMessage} className={styles.messageForm}>
                    <input
                      type="text"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      placeholder="Type your message..."
                      required
                    />
                    <div className={styles.fileInputContainer}>
                      <input type="file" id="imageUpload" className={styles.fileInput} accept="image/*" onChange={handleImageChange} />
                      <label htmlFor="imageUpload" className={styles.cameraIcon}></label>
                    </div>
                      <PlotInput selectedPlot={selectedPlot} plots={plots} setSelectedPlot={setSelectedPlot}/>
                    <button type="submit">Send</button>
                  </form> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    {/* <div className={styles.messageContainer}>
      <div className={styles.receiverList}>
        <h3>Users</h3>
        <ul>
          {users.map((user) => (
            <li
              key={user.id}
              className={selectedReceiver && user.id === selectedReceiver.id && !isGroup ? styles.selectedReceiver : ''}
              onClick={() => { setSelectedReceiver(user); setIsGroup(false); }}
            >
              {user.username}
            </li>
          ))}
        </ul>
        <h3>Groups</h3>
        <ul>
          {groups.map((group) => (
            <li
              key={group.id}
              className={selectedReceiver && group.id === selectedReceiver.id && isGroup ? styles.selectedReceiver : ''}
              onClick={() => { setSelectedReceiver(group); setIsGroup(true); }}
            >
              {group.name}
            </li>
          ))}
        </ul>
        <button onClick={() => setShowCreateGroup(true)}>Create Group</button>
        {showCreateGroup && (
          <form onSubmit={handleCreateGroup} className={styles.createGroupForm}>
            <input
              type="text"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
              placeholder="Group Name"
              required
            />
            <div className={styles.userSelect}>
              {users.map((user) => (
                <label key={user.id}>
                  <input
                    type="checkbox"
                    value={user.id}
                    onChange={(e) => {
                      const userId = parseInt(e.target.value);
                      setSelectedGroupUsers((prev) =>
                        e.target.checked ? [...prev, userId] : prev.filter((id) => id !== userId)
                      );
                    }}
                  />
                  {user.username}
                </label>
              ))}
            </div>
            <button type="submit">Create</button>
            <button type="button" onClick={() => setShowCreateGroup(false)}>Cancel</button>
          </form>
        )}
      </div>
      <div className={styles.messageBox}>
        <div className={styles.chatHeaderContainer}>
        {selectedReceiver && (
        <>
          <div className={styles.chatHeader}>
            {isGroup ? selectedReceiver.name : selectedReceiver.username}
          </div>
            <div className={styles.searchBar}>
              <input
                type="text"
                placeholder="Search messages..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={styles.searchInput}
              />  
            </div>
        </>
        )}
        </div>
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.messages}>
          {filteredMessages.map((message) => {
           const isCurrentUser = isGroup 
           ? groupMembers.some(() => currentUser.id !== message.senderId)    
           : message.senderId === selectedReceiver?.id;        
           
            const messageClass = isCurrentUser ? styles.sender : styles.user;
            const backgroundColor = isGroup ? getUserColorById(message.senderId) : (isCurrentUser ? '' : getUserColorById(message.senderId));
           
            return (
                <div
                  key={message.id}
                  className={`${styles.chatMessage} ${messageClass}`}
                  style={{ backgroundColor }}
                >
                  <p>{message.content}</p>
                  {message.image && (
                    <img
                      src={`${process.env.REACT_APP_URL}uploads/${message.image}`}
                      alt="Attached"
                      className={styles.messageImage}
                    />
                  )}
                  {message.plotId && (
                    <p>
                      Tagged Plot: {plots.find((p) => p.plotId === message.plotId)?.plotId}
                    </p>
                  )}
                  <span className={styles.messageSender}>
                    {getUserById(message.senderId)}
                  </span>
                </div>
              );
          })}
        </div>
        <form onSubmit={handleSendMessage} className={styles.messageForm}>
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Type your message..."
            required
          />
          <div className={styles.fileInputContainer}>
            <input type="file" id="imageUpload" className={styles.fileInput} accept="image/*" onChange={handleImageChange} />
            <label htmlFor="imageUpload" className={styles.cameraIcon}></label>
          </div>
            <PlotInput selectedPlot={selectedPlot} plots={plots} setSelectedPlot={setSelectedPlot}/>
          <button type="submit">Send</button>
        </form>
      </div>
    </div> */}
    </>
  );
};

export default Message;
